import { SvgIcon } from "@mui/material"

interface IProps {
  sx?: any
}

export function IconCubeSpark(props: Readonly<IProps>): React.JSX.Element {
  const { sx } = props

  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fillOpacity={0}
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      sx={{
        width: sx?.width ?? "24",
        height: sx?.height ?? "24",
        color: sx?.color ?? "inherit",
      }}>
      <path d="M21 12v-4.01a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.02 2.02 0 0 0 -2 0l-7 4.008c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008c.62 .354 1.38 .354 2 0" />
      <path d="M12 22v-10" />
      <path d="M12 12l8.73 -5.04" />
      <path d="M3.27 6.96l8.73 5.04" />
      <path d="M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5" />
    </SvgIcon>
  )
}
